import { DeviceOfflineContentSkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/offline/DeviceOfflineContentSkeleton';
import { Suspense, useContext } from 'react';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { useHeartbeatStatus } from 'app/agriculture/routes/Devices/utils/status/heartbeatStatus/useHeartbeatStatus';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useThrottledNow } from 'app/agriculture/AgTimeline/hooks/useThrottledNow';
import { DeviceOfflineContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/offline/DeviceOfflineContent';

export function DeviceOffline() {
    const { device } = useContext(DeviceDetailContext);
    const now = useThrottledNow();
    const { status } = useHeartbeatStatus({ deviceId: device.id, cursorTimeOverride: now });
    if (status !== 'error') return null;

    return (
        <Suspense fallback={<DeviceOfflineContentSkeleton />}>
            <ContentBox.Section disableDivider>
                <DeviceOfflineContent />
            </ContentBox.Section>
        </Suspense>
    );
}
